var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 0.549805C4.34079 0.549805 0.550049 4.34055 0.550049 8.9998C0.550049 13.6591 4.34079 17.4498 9.00005 17.4498C13.6593 17.4498 17.45 13.6591 17.45 8.9998C17.45 4.34055 13.6593 0.549805 9.00005 0.549805Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 10.6774C9.92048 11.4758 8.53002 11.4758 7.73164 10.6774C7.33245 10.2782 7.11276 9.74802 7.11276 9.18379C7.11276 8.61957 7.33247 8.08938 7.73165 7.69019C8.53002 6.89181 9.92048 6.89181 10.7189 7.69019L12.2125 6.19659C10.6167 4.59983 7.83376 4.59983 6.23804 6.19659C5.43966 6.99445 5.00024 8.05534 5.00024 9.18379C5.00024 10.3122 5.43967 11.3731 6.23804 12.171C7.0359 12.9694 8.09679 13.4088 9.22524 13.4088C10.3537 13.4088 11.4146 12.9694 12.2124 12.171L10.7188 10.6774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPolicy);
export default __webpack_public_path__ + "static/media/c-policy.1a15c6d3bde7b109b6631521db0f4a9b.svg";
export { ForwardRef as ReactComponent };